import React from "react";
import { Grid } from "material-ui";
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import { CardContent } from "material-ui";
import { HeatMapChart } from "./HeatMapChart";

export class HeatMapCard extends React.Component {
  
  render() {
    const { 
      t,
      i18n,
      classes, 
      chartName,
      loading,
      title,
      subheader,
      avatar,
      heatMapData
    } = this.props;

    if (loading) { return false }

    return (
      <Grid item xs={12} sm={12}>
        <Card
          key={`${chartName}-card`}
          className={classes.card}
        >
          <CardHeader
            key={`${chartName}-cardheader`}
            avatar={avatar}
            title={title}
            subheader={subheader}
          />
          <CardContent
            key={`${chartName}-cardcontent`}
            style={{
              height: 400,
              marginBottom: 60
            }}
          >
						<HeatMapChart 
							key={`${chartName}-chart`}
							ref={ref => { this.chart = ref; }}
							t={t} 
							classes={classes}
							heatMapData={heatMapData}
							loading={loading}
							i18n={i18n}
						/>
          </CardContent>
        </Card>
      </Grid>
    ); 
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/HeatMapCard.js